module.exports = __webpack_public_path__ + "img/head.ab23e70e.png";